import React from 'react';

import useRect from '@lyearn/core/hooks/useRect';
import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';
import { Image as ImageComponent } from '@/components/Image';
import { useBaseCard } from '@/modules/content/components/ContentCard/BaseCard/Provider';
import {
  BaseCardComposition,
  BaseCardImageTransitionType,
} from '@/modules/content/components/ContentCard/BaseCard/types';

import { imageOverlayStyles, TRANSITION_CLASSES } from './styles';

const Image: BaseCardComposition['Image'] = (props) => {
  const {
    className,
    style,
    children,
    containerClassName,
    containerStyle,
    width: _width,
    height: _height,
    layout,
    transitionType = BaseCardImageTransitionType.GroupHover,
  } = props;

  const { image, name, disabled } = useBaseCard();
  const transitionClassName = TRANSITION_CLASSES[transitionType];

  const { width = _width, height = _height, onLayout, ref } = useRect();

  if (!image) {
    return null;
  }

  return (
    <Box
      ref={ref}
      className={cn('relative transform-gpu overflow-hidden', containerClassName)}
      style={containerStyle}
      onLayout={onLayout}>
      {width && height ? (
        <ImageComponent
          alt={name!}
          className={cn({ [transitionClassName]: !disabled }, className)}
          disabled={disabled}
          height={height ? Number(height) : undefined}
          layout={layout}
          src={image}
          style={style}
          width={width ? Number(width) : undefined}
        />
      ) : null}
      <Box className={cn('pointer-events-none absolute inset-0', imageOverlayStyles)} />
      {children}
    </Box>
  );
};

export default Image;
